import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerConfigService } from '@app/configuration/server-config.service';
import { TermsOfUseAgreementDto } from '@imcc/transport';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class TermsOfUseAgreementRepository {
  private config: any;

  constructor(
    private httpClient: HttpClient,
    private configService: ServerConfigService,
  ) {
    this.config = this.configService.config;
  }

  findAfter(date: Date): Observable<TermsOfUseAgreementDto[]> {
    const httpParams = new HttpParams().set('after', date.toISOString());
    const options = { params: httpParams };
    const request = this.httpClient.get(this.urlPath(), options);

    return request.pipe(
      map((result: any[]) => plainToClass(TermsOfUseAgreementDto, result)),
      take(1),
    );
  }

  create(): Observable<TermsOfUseAgreementDto> {
    const request = this.httpClient.post(this.urlPath(), {});

    return request.pipe(
      map((result) => plainToClass(TermsOfUseAgreementDto, result)),
      take(1),
    );
  }

  private urlPath(): string {
    const { apiBaseUrl } = this.config;

    return `${apiBaseUrl}/terms-of-use-agreements`;
  }
}
